import { useEffect, useRef, useState } from "react";
import { useTraderProvider } from "../../providers/TraderProvider";
import { useAuth } from "../../providers/AuthenticationProvider";
import RevenueChart from "./RevenueChart";
import { Box } from "@mui/material";
import MonthDataElement from "./MonthData";
import React from "react";
import { MonthData } from "../../types/Trader/Trader";

const HorizontalScrollableContainer = ({
	monthlyHistory,
}: {
	monthlyHistory: MonthData[];
}) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [isDragging, setIsDragging] = useState<boolean>(false);
	const [startX, setStartX] = useState<number>(0);
	const [scrollLeft, setScrollLeft] = useState<number>(0);

	const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
		setIsDragging(true);
		setStartX(event.pageX - (containerRef.current?.offsetLeft || 0));
		setScrollLeft(containerRef.current?.scrollLeft || 0);
	};

	const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
		if (!isDragging || !containerRef.current) return;
		const x = event.pageX - (containerRef.current?.offsetLeft || 0);
		const scrollX = x - startX;
		containerRef.current.scrollLeft = scrollLeft - scrollX;
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	return (
		<Box
			ref={containerRef}
			sx={{
				width: "100%",
				overflowX: "auto",
				cursor: isDragging ? "grabbing" : "grab",
				scrollbarWidth: "none",
			}}
			onMouseDown={handleMouseDown}
			onMouseMove={handleMouseMove}
			onMouseUp={handleMouseUp}
			onMouseLeave={handleMouseUp}
		>
			<div
				style={{
					display: "flex",
					gap: "32px",
					alignItems: "center",
					whiteSpace: "nowrap",
				}}
			>
				{monthlyHistory.map((value, index) => (
					<MonthDataElement key={index} data={value} />
				))}
			</div>
		</Box>
	);
};

const MontlyData = () => {
	const { monthlyHistory, getMonthlyHistory, currentTraderProfile } =
		useTraderProvider();
	useEffect(() => {
		if (currentTraderProfile == null) return;
		getMonthlyHistory(currentTraderProfile.uid);
	}, [currentTraderProfile]);

	return (
		<Box
			sx={{
				width: "100%",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				borderRadius: "16px",
				gap: "32px",
			}}
		>
			{monthlyHistory != null && (
				<HorizontalScrollableContainer
					monthlyHistory={monthlyHistory.monthlyHistory}
				/>
			)}
			<Box
				sx={{
					width: "100%",
				}}
			>
				{monthlyHistory != null && (
					<RevenueChart monthlyHistory={monthlyHistory} />
				)}
			</Box>
		</Box>
	);
};

export default MontlyData;
